import { Page } from "components/layout/Layout";
import { Container } from "components/layout/Container";
import { Breadcrumbs } from "components/shared/Breadcrumbs";
import { Title } from "components/typography/Title";
import { TSearchEngine } from "./TSearchEngine";

import styles from "components/pages/blog/CategoryPage.module.scss";
import { useCategorySinglePageContext } from "@/helpers/contexts/CategorySinglePageContext";
import { getCategoryPageArticleFullData } from "@/helpers/api/requests/blog/category/categoryPage";
import useBlogSearch, { SearchFilterEntity } from "@/helpers/blog/useBlogSearch";
import { StrapiSearchResult } from "@/types/strapi/shared";
import { StrapiArticleData } from "@/types/strapi/article";
import { requestTranslationCategoryPageArticles } from "@/helpers/api/requests/blog/translations/translationCategoryPage";
import { requestTranslationSubcategoryPageArticles } from "@/helpers/api/requests/blog/translations/translationSubcategoryPage";
import { ArticlesList } from "@/components/pages/blog/search/ArticlesList";
import { PageGradientWrapper } from "@/components/layout/PageGradientWrapper";
import s from "@/components/pages/blog/CategoryPage.module.scss";
import { BlogSearch } from "@/components/pages/blog/search/BlogSearch";

type TCategoryPageProps = {
  showSubcategory?: boolean;
  notFound: boolean;
  search: string;
};

export const TCategoryPage = ({ showSubcategory, notFound }: TCategoryPageProps) => {
  const data = useCategorySinglePageContext();
  const { search, handleSearch } = useBlogSearch();
  if (!data) return null;
  const { category, breadcrumbsList, pagination, subcategoriesSlugs } = data;

  const { meta, heading, articles, subcategories, slug } = category;

  return (
    <Page headerColor="black" {...meta}>
      <PageGradientWrapper>
        <Container className={styles.top}>
          <Breadcrumbs color="black" list={breadcrumbsList} />
          <Title level={1} html={heading} className={styles.heading} />
          <BlogSearch
            search={search}
            count={pagination.total}
            handleSearch={handleSearch}
            isNotFound={notFound}
            className={s.blogSearch}
          />
        </Container>

        <TSearchEngine
          isSearch={!notFound && !!search}
          taxonomyHeading={"Subcategories"}
          taxonomies={subcategories}
          filteredArticles={articles}
          isLoading={false}
          pagination={pagination}
          listClassName={styles.list}
          showSubcategory={showSubcategory}
        >
          {!!articles.length ? (
            <ArticlesList
              list={articles}
              pagination={pagination}
              className={styles.list}
              showSubcategory={showSubcategory}
              urlPrefix="/translations"
              includeTaxonomyInURL={false}
            />
          ) : (
            <Container>
              <div style={{ padding: "60px 0 80px" }}>There&apos;s nothing here yet</div>
            </Container>
          )}
        </TSearchEngine>
      </PageGradientWrapper>
    </Page>
  );
};
